import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IRunVetComplianceDraftPayload } from "../types";
import { readApiError } from "./readApiError";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS],
  skipInvalidation: false,
};

export function useRunDraftVetCompliance() {
  const runDraftVetCompliance = useCallback(
    (payload: IRunVetComplianceDraftPayload) =>
      AiWorkspaceService.runDraftVetCompliance(payload)
        .then((res) => {
          ToastService.success("Draft check started");
          return res;
        })
        .catch(async (err) => {
          ToastService.error(
            await readApiError(err, "Failed to run draft check")
          );
          throw err;
        }),
    []
  );

  const {
    mutate: run,
    isLoading: isRunning,
    isSuccess: hasRun,
  } = useMutation<IRunVetComplianceDraftPayload>({
    mutationFn: runDraftVetCompliance,
    options: QUERY_OPTIONS,
    onSuccess: (queryClient, _data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          AI_WORKSPACE_QUERY_KEYS.REQUEST,
          variables.aiWorkspaceRequestId,
        ],
      });
    },
  });

  return { run, isRunning, hasRun };
}
